export default __webpack_public_path__ + "static/media-leaves-511e299662e19ba8b0cd0151ac34ee4a.png";